//#region Angular Imports

import { IQService, IDirective } from 'angular'

//#endregion

//#region DevExtreme Import

import 'devextreme/ui/button'
import 'devextreme/ui/popover'
import 'devextreme/ui/select_box'

//#endregion

import { ExportScope, ExportController } from "./export.directive.controller"

import { DATA_TYPE_SERVICE_NAME, DataTypeService } from "../../../services/data-type"
import { EXPORT_SERVICE_NAME, ExportService } from '../../../services/export'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from "../../../services/user-session"

//#region Assets Import

import './export.scss'
import * as TEMPLATE from './export.tpl.html'

//#endregion

export class ExportDirective implements IDirective {
    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        DATA_TYPE_SERVICE_NAME,
        EXPORT_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME, (
            $scope: ExportScope,
            $q: IQService,
            dataTypeServie: DataTypeService,
            exportService: ExportService,
            userSessionService: UserSessionService
        ) => new ExportController($scope, $q, dataTypeServie, exportService, userSessionService)]

    restrict = 'E'

    scope = {
        popupId: '=',
        options: '=?'
    }

    template = TEMPLATE
}